import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, of, tap } from 'rxjs';
import { InitiatorService } from './initiator.service';
import { ClientFeature, ClientFeatureSchema } from '../models/client-feature';

@Injectable({
  providedIn: 'root',
})
export class ClientFeatureService {
  clientFeatures: ClientFeature = {};
  private http = inject(HttpClient);
  private initiatorService = inject(InitiatorService);

  load() {
    const clientId = this.initiatorService.clientId;
    return this.http
      .get<ClientFeature>(`/assets/features/clients/${clientId}.json`)
      .pipe(
        map((clientFeaturesData) => {
          const result = ClientFeatureSchema.safeParse(clientFeaturesData);
          if (!result.success) {
            console.error('JSON does not match schema', result.error);
          }
          return clientFeaturesData;
        }),
        tap((clientFeatures) => {
          this.clientFeatures = clientFeatures;
        }),
        catchError((error: HttpErrorResponse) => {
          console.warn('Client features not found', error.message);
          return of({});
        }),
      );
  }
}
